<template>
  <div>
    <PrimaryButton light @click.native="openDialog" shrink>
      Edit
      <v-icon class="ml-3">mdi-pencil</v-icon>
    </PrimaryButton>
    <EditQualificationsDialog
      :isOpen="isDialogOpen"
      @close="closeDialog"
      v-if="isDialogOpen"
    />
  </div>
</template>

<script>
import EditQualificationsDialog from "@/views/settings/components/dialogs/EditQualificationsDialog";
import PrimaryButton from "@/components/common/Button/PrimaryButton";

export default {
  name: "EditQualificationsAction",
  components: { PrimaryButton, EditQualificationsDialog },
  data() {
    return {
      isDialogOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isDialogOpen = true;
    },
    closeDialog() {
      this.isDialogOpen = false;
    }
  }
};
</script>

<style scoped></style>
